import React, { useEffect, useRef, useMemo } from "react";
import { animateScroll as scroll } from "react-scroll"; // Smooth scroll functionality
import "./HeroSection5.css";

const HeroSection1 = () => {
  const vantaRef = useRef(null); // Ref for Vanta.js
  
  // Memoized Vanta.js configuration
  const VANTA_CONFIG = useMemo(() => ({
    mouseControls: true,
    touchControls: true,
    gyroControls: false,
    minHeight: 700.0,
    minWidth: 500.0,
    scale: 1.0,
    color1: 0x061826, // Adjusted to a darker green-black
    color2: 0x51386F, // Brighter green for better contrast
    size: 1.5,       // Increase cell size for better visibility
  }), []);

  useEffect(() => {
    let vantaEffect;

    const setVanta = () => {
      if (window.VANTA && vantaRef.current) {
        vantaEffect = window.VANTA.CELLS({
          el: vantaRef.current,
          ...VANTA_CONFIG,
        });
      } else {
        console.warn("Vanta.js is not loaded or element is missing");
      }
    };

    setVanta();

    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [VANTA_CONFIG]);

  useEffect(() => {
    let animation;
    if (window.anime) {
      animation = window.anime({
        targets: ".animated-title",
        translateY: [-20, 0], // Subtle upward movement
        opacity: [0, 1], // Gradual fade-in
        duration: 3000, // Smooth animation
        easing: "easeOutQuad", // Softer easing
        delay: 500, // Start delay
      });
    }

    return () => {
      if (animation) animation.pause();
    };
  }, []);

  const handleScroll = () => {
    const nextSection = document.getElementById("presentation"); // Adjust to the next section's ID
    if (nextSection) {
      scroll.scrollTo(nextSection.offsetTop, {
        duration: 1000, // Smooth scroll duration
        smooth: "easeInOutCubic",
      });
    } else {
      console.warn("Target section not found");
    }
  };

  return (
    <section
      id="hero"
      className="hero-section"
      ref={vantaRef} // Attach Vanta.js to this element
    >
      <div className="hero-content">
        {/* Animated Title */}
        <h1
          className="animated-title"
          onClick={handleScroll} // Scroll functionality
          role="button" // Semantic for accessibility
          tabIndex="0" // Focusable with keyboard
          aria-label="Scroll to the presentation section"
        >
          SC Chat Analyzer - Improve your wellbeing
          <span className="left"></span>
          <span className="right"></span>
        </h1>

        {/* Button */}
        <button 
          className="hero-button"
          onClick={() => window.location.href = "https://chatanalyzer.socialcompass.ai/"}
        >
          Explore
        </button>
      </div>
    </section>
  );
};

export default HeroSection1;
